import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSortModule } from "@angular/material/sort";
import { EneIconModule } from "src/app/shared/ui/icon/legacy/icon.module";
import { TranslateModule } from "@ngx-translate/core";
import { CommonDirectivesModule } from "../../directives/directives.module";
import { PipesModule } from "../../pipes/pipes.module";
import { SkeletonLoaderModule } from "../skeleton-loader/skeleton-loader.module";
import { TableComponent } from "./components/container/table.component";
import { StatusDescriptionComponent } from "./components/status-description/status-description.component";
import { TableCellComponent } from "./components/table-cells/table-cell/table-cell.component";
import { TableCombinedValuesCellComponent } from "./components/table-cells/table-combined-value-cell/table-combined-values-cell.component";
import { TableFilterComponent } from "./components/table-filter/table-filter.component";
import { TablePaginatorComponent } from "./components/table-paginator/table-paginator.component";
import { TableTemplateTransformPipe } from "./pipes/table-template-transform.pipe";

const materialModules = [
  MatTableModule,
  MatFormFieldModule,
  MatInputModule,
  MatPaginatorModule,
  MatSortModule,
  MatTooltipModule,
  MatButtonModule,
  MatCheckboxModule
];

const pipes = [TableTemplateTransformPipe];

const components = [
  TableComponent,
  TableCellComponent,
  TableCombinedValuesCellComponent,
  TableFilterComponent,
  TablePaginatorComponent,
  StatusDescriptionComponent
];

@NgModule({
  declarations: [...pipes, ...components],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    EneIconModule,
    CommonDirectivesModule,
    PipesModule,
    SkeletonLoaderModule,
    ...materialModules
  ],
  exports: [...pipes, ...components]
})
export class TableModule {}
